export const RESULTS_PER_BATCH_COUNT = 100
export const MAX_BATCHES_PER_FIELD_COUNT = 3
